import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { WarningCircle, ArrowRight, X } from "@phosphor-icons/react";

export default function PreviewBanner() {
  const [mode, setMode] = useState(null);
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && sessionStorage.getItem("previewBannerDismissed") === "1"
  );

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/settings/whatsapp");
        setMode(r.data);
      } catch (_) { /* not signed in yet */ }
    })();
  }, []);

  if (!mode || mode.mode !== "simulated" || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem("previewBannerDismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="preview-banner"
      className="mb-6 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 flex items-center gap-3"
    >
      <WarningCircle size={18} weight="fill" className="text-amber-600 shrink-0" />
      <div className="flex-1 text-sm text-amber-900">
        <span className="font-semibold">Preview mode.</span>{" "}
        WhatsApp outbound is <span className="font-mono">simulated</span> — replies and flash reports are recorded in threads and the Activity Log but no real messages leave your line.
        Use <span className="font-semibold">Simulate inbound</span> on the Inbox to fake incoming messages.
      </div>
      <Link
        to="/whatsapp"
        data-testid="preview-banner-connect"
        className="text-amber-900 hover:text-amber-700 text-xs font-semibold inline-flex items-center gap-1 whitespace-nowrap"
      >
        Connect Meta <ArrowRight size={12} weight="bold" />
      </Link>
      <button
        onClick={dismiss}
        data-testid="preview-banner-dismiss"
        className="text-amber-700 hover:text-amber-900 rounded p-1"
        aria-label="Dismiss"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
